<template>
  <v-card class="pa-3" width="480">
    <v-card-title class="headline">
      <font-awesome-icon
        class="mr-2"
        :style="{ color: '#424242' }"
        size="lg"
        :icon="['fal', 'calendar-times']"
      />
      Agregar Fecha de Finalización
    </v-card-title>
    <v-card-text>
      <v-flex pa-3>
        <v-flex>
          Por favor elegir Fecha de Finalización
        </v-flex>
        <v-flex>
          <!-- END DAY -->
          <v-menu
            v-model="menuEndDate"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            color="#C46D24"
          >
            <template v-slot:activator="{ on }">
              <VTextField
                class="text-field-width"
                v-model="userEndDayCRUD"
                label="Fecha de Finalización - DD/MM/AAAA"
                color="#C46D24"
                readonly
                v-on="on"
                :disabled="disableAll"
                required
                :rules="[v => !!v || 'Item requerido']"
              ></VTextField>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              color="#C46D24"
              locale="es-co"
              :allowed-dates="allowedDates"
              @input="menuEndDate = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-divider class="my-2"></v-divider>
        <v-flex class="body-2 grey--text text--darken-2">
          Por favor confirmar que desea agregar
          <b>Fecha de Finalización</b> del siguiente usuario:
        </v-flex>
        <v-flex py-3>
          <h4>{{ userData.fullName }}</h4>
          <h3>{{ userData.email }}</h3>
        </v-flex>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- v-if="showCancelBtn" -->
      <v-btn
        class="text-capitalize"
        color="red darken-1"
        dark
        depressed
        @click="cancel"
      >
        <font-awesome-icon
          class="mr-2"
          :style="{ color: '#FFFFFF' }"
          size="lg"
          :icon="['fal', 'times-circle']"
        />
        Cancelar
      </v-btn>

      <!-- v-if="showSendBtn" -->
      <v-btn
        class="text-capitalize"
        color="#466EA5"
        depressed
        :dark="date !== null"
        :disabled="date === null"
        @click="accept"
      >
        <font-awesome-icon
          class="mr-2"
          :style="{ color: '#FFFFFF' }"
          size="lg"
          :icon="['fal', 'paper-plane']"
        />
        Enviar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AddEndDate",
  props: {
    userData: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      date: null,
      menuEndDate: false
    };
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    }
  },
  computed: {
    ...mapGetters(["currentYear", "currentMonthNumber", "disableAll"]),
    userEndDayCRUD() {
      return this.formatDate(this.date);
    }
  },
  methods: {
    ...mapActions(["addEndDate"]),
    getNextMonth() {
      let yearTemp = Number(this.currentYear);
      let nextMonthTemp = this.currentMonthNumber + 2;
      if (nextMonthTemp > 9) {
        if (nextMonthTemp >= 13) {
          yearTemp = yearTemp + 1;
          return `${String(yearTemp)}-01-01`;
        } else return `${String(yearTemp)}-${String(nextMonthTemp)}-01`;
      } else return `${String(yearTemp)}-0${String(nextMonthTemp)}-01`;
    },
    allowedDates(date) {
      // console.log("DATE", date);
      // const startNextMonth = this.getNextMonth();
      // console.log("START NEXT MONTH", startNextMonth);

      const startDateSplit = this.userData.startDate.split("/");
      const startDateFormated = `${startDateSplit[2]}-${startDateSplit[1]}-${startDateSplit[0]}`;
      // console.log(startDateFormated);
      // let result = date >= startDateFormated && date < startNextMonth;
      let result = date > startDateFormated;
      return result;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    accept() {
      console.log("SEND AED!");
      const endDateSplit = this.date.split("-");
      const endDateFormated = `${endDateSplit[2]}/${endDateSplit[1]}/${endDateSplit[0]}`;
      const data = {
        endDate: endDateFormated,
        uid: this.userData.uid
      };
      this.addEndDate(data);
      this.$emit("cancelAddEndDate");
    },
    cancel() {
      this.date = null;
      this.$emit("cancelAddEndDate");
    }
  }
};
</script>

<style lang="stylus" scoped>
h3
  color #424242
  font-weight 600
  font-size 16px

h4
  color #616161
</style>
